import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * ScrollToTop — B-56 (9 Oct 2026). A new page opens at the top.
 *
 * Without it the SPA kept the previous page's scroll position: Register's
 * button is at the bottom of a long form, so My Clubs opened 40px down with
 * its "Welcome" header tucked under the navbar.
 *
 * Only on a change of PAGE (pathname): `?tab=` switches inside Admin and
 * `#anchor` links are left alone. Back/Forward (POP) keep the browser's own
 * scroll restoration. Renders nothing.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();
  const lastPath = useRef(pathname);

  useEffect(() => {
    if (pathname === lastPath.current) return;
    lastPath.current = pathname;
    if (navigationType === 'POP' || hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash, navigationType]);

  return null;
}
